import { UserAvatar } from "./UserAvatar";
import { OnlineStatusBadge } from "../organization/OrganizationList.style";
import React from "react";
import { useMediaUrlWithState } from "hhn-commons";

interface DisplayDynamicAvatarImageProps {
  src: string;
  showOnlineStatusBadge: boolean;
  isOnline: boolean;
  alt: string;
  avatarSize: number;
  onlyFirstNameInitial: boolean;
}

export const DisplayDynamicAvatarImage = ({
  src,
  showOnlineStatusBadge = false,
  isOnline = false,
  alt,
  avatarSize,
  onlyFirstNameInitial = false,
}: DisplayDynamicAvatarImageProps) => {
  const mediaState = useMediaUrlWithState(src);
  const avatarSrc = mediaState.data?.signedUrl;
  return (
    <>
      {showOnlineStatusBadge ? (
        <OnlineStatusBadge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          variant="dot"
          isOnline={isOnline}
          data-testid="status-badge"
        >
          <UserAvatar
            src={avatarSrc}
            alt={alt}
            avatarSize={avatarSize}
            onlyFirstNameInitial={onlyFirstNameInitial}
          />
        </OnlineStatusBadge>
      ) : (
        <UserAvatar
          src={avatarSrc}
          alt={alt}
          avatarSize={avatarSize}
          onlyFirstNameInitial={onlyFirstNameInitial}
        />
      )}
    </>
  );
};
